import instance from '../../api/instance'
const path = '/wv/search_nps'

export default {
    async questions(surveyId) {
        return await instance(window.config['application_host']).get(path + `/questions.json?survey_id=${surveyId}`)
    },
    async submit(params) {
        return await instance(window.config['application_host']).post(path + '/submit', params)
    }
}
